import { render, staticRenderFns } from "./QuotationSelectSubModality.vue?vue&type=template&id=5f8ef5f6"
import script from "./QuotationSelectSubModality.vue?vue&type=script&lang=js"
export * from "./QuotationSelectSubModality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports